import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.shippingAddressTitle = mergeToNew(
    savedOrderDetailsOrderInformationStyles.shippingAddressTitle,
    {
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
            width: 100%;

            @media print {
                padding: 0 0 4px;
                margin: 0;
                background: transparent;
                * {
                    font-size: 0.625rem;
                }
            }
        `,
    },
);
savedOrderDetailsOrderInformationStyles.billingAddressTitle = mergeToNew(
    savedOrderDetailsOrderInformationStyles.billingAddressTitle,
    {
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
            width: 100%;

            @media print {
                padding: 0 0 4px;
                margin: 0;
                background: transparent;
                * {
                    font-size: 0.625rem;
                }
            }
        `,
    },
);

savedOrderDetailsOrderInformationStyles.billingAddress = mergeToNew(
    savedOrderDetailsOrderInformationStyles.billingAddress,
    {
        wrapper: {
            css: css`
                padding: 16px;

                @media print {
                    padding: 0;
                }
            `,
        },
    },
);
savedOrderDetailsOrderInformationStyles.shippingAddress = mergeToNew(
    savedOrderDetailsOrderInformationStyles.shippingAddress,
    {
        wrapper: {
            css: css`
                padding: 16px;
                @media print {
                    padding: 0;
                }
            `,
        },
    },
);
savedOrderDetailsOrderInformationStyles.orderDateText = mergeToNew(
    savedOrderDetailsOrderInformationStyles.orderDateText,
    {
        css: css`
            padding: 16px;
            @media print {
                padding: 0;
            }
        `,
    },
);

savedOrderDetailsOrderInformationStyles.orderDateTitle = mergeToNew(
    savedOrderDetailsOrderInformationStyles.orderDateTitle,
    {
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
            width: 100%;

            @media print {
                padding: 0 0 4px;
                margin: 0;
                background: transparent;
                * {
                    font-size: 0.625rem;
                }
            }
        `,
    },
);
